import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';

// this is not a very nice approach, but clm-portal doesn't currently support
// theme switching, and it would be a much larger task to make it support it
// export const nonProductionColor = '#00661d';
export const nonProductionColor = '#298C29';
export const productionColor = '#001388';

const typography = {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#232156',
    main: productionColor,
    light: colors.indigo[100],
  },
  secondary: {
    contrastText: white,
    blueGray: '#8A92CC',
    dark: colors.blue[900],
    main: colors.blue['A400'],
    light: colors.blue['A400'],
    lighter: colors.blue['A100'],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[600],
    light: colors.green[400],
    highlight: '#7BAFA3',
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
    alertBg: '#F5E8CC',
    alertColor: '#D6A133',
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: '#001489',
    secondary: colors.blueGrey[600],
    link: colors.blue[600],
  },
  background: {
    default: '#ffffff',
    paper: white,
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
  grey: {
    contrastText: white,
    dark: '#8d9697',
    darker: '#384142',
    main: '#f0f0f1',
    light: '#f5f5f5',
    lighter: '#f1f2f2',
    brownGrey: '#eeede4',
  },
  brown: {
    darkBrown: '#c0ba97',
    darkerBrown: '#cc8a00',
  },
  oceanblue: {
    main: '#339e91',
  },
};

export default typography;
